export default __webpack_public_path__ + "static/media/imageTwo.3e1721fd.jpg";